export default {
  startingLineups: {
    title: "Alineaciones iniciales",
    labels: {
      confirmed: "CONFIRMADO",
      expected: "PREVISTO",
      tbd: "POR DEFINIR",
      noLineupAvailable: "No hay alineación disponible",
    },
    empty: {
      title: "No hay alineaciones disponibles",
    },
  },
};